import { render, staticRenderFns } from "./revenue_partner.vue?vue&type=template&id=63aaa7cc&"
import script from "./revenue_partner.vue?vue&type=script&lang=js&"
export * from "./revenue_partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports